import Axios from 'axios';

async function DatabaseDocument(data)
{
    const url = `https://docsserver.onrender.com/sheets/create`;

    try
    {
        let res = await Axios.post(url, data);
        if(res.data !== "created")
        {
            //console.log("Something Gone Wrong");
        }
    }
    catch(err)
    {
        //console.log(err);
    }
}

export default DatabaseDocument;